import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import '@/assets/css/main.css'
import VClickOutside from 'click-outside-vue3'
import DevicePlugin from '@/plugins/device'
import UsingMousePlugin from '@/plugins/using-mouse'
import UniqueId from '@/plugins/unique-id'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import { analyticsSetup } from './utils/analytics'

const TEMPORARY_TARGET_ATTRIBUTE = 'data-temp-target';

analyticsSetup()

createApp(App)
  .use(router)
  .use(createPinia())
  .use(VClickOutside)
  .use(DevicePlugin)
  .use(UniqueId, { uidPrefix: 'k' })
  .use(UsingMousePlugin)
  .use(VueDOMPurifyHTML, {
    hooks: {
      beforeSanitizeAttributes: (node) => {
        if ('target' in node) {
          node.setAttribute(TEMPORARY_TARGET_ATTRIBUTE, node.getAttribute('target'))
        }
      },
      afterSanitizeAttributes: (node) => {
        if ('target' in node) {
          node.setAttribute('target', node.getAttribute(TEMPORARY_TARGET_ATTRIBUTE))
          node.removeAttribute(TEMPORARY_TARGET_ATTRIBUTE)
        }
      }   
    },
    namedConfigurations: {
      svg: {
        USE_PROFILES: { svg: true },
        FORBID_ATTR: ['style', 'fill', 'id', 'class'],
        FORBID_TAGS: ['style']
      }
    }
  })
  .mount('#app')
